import Parse from "parse";

import type { _User } from "./_User";
import type { SIV_DeliveryNotes } from "./SIV_DeliveryNotes";
import type { SIV_Order } from "./SIV_Order";
import type { SIV_Package } from "./SIV_Package";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_DeliveryNotePackageAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  changedAt?: Date | undefined;
  changedBy?: _User | undefined;
  deliveryNote: SIV_DeliveryNotes;
  notFoundValues: any;
  order: SIV_Order;
  package: SIV_Package;
  tenant: OD3_Tenant;
}

export class SIV_DeliveryNotePackage extends Parse.Object<SIV_DeliveryNotePackageAttributes> {
  static className: string = "SIV_DeliveryNotePackage";

  constructor(data?: Partial<SIV_DeliveryNotePackageAttributes>) {
    super("SIV_DeliveryNotePackage", data as SIV_DeliveryNotePackageAttributes);
  }

  get changedAt(): Date | undefined {
    return super.get("changedAt");
  }
  set changedAt(value: Date | undefined) {
    super.set("changedAt", value);
  }

  get changedBy(): _User | undefined {
    return super.get("changedBy");
  }
  set changedBy(value: _User | undefined) {
    super.set("changedBy", value);
  }

  get deliveryNote(): SIV_DeliveryNotes {
    return super.get("deliveryNote");
  }
  set deliveryNote(value: SIV_DeliveryNotes) {
    super.set("deliveryNote", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get order(): SIV_Order {
    return super.get("order");
  }
  set order(value: SIV_Order) {
    super.set("order", value);
  }

  get package(): SIV_Package {
    return super.get("package");
  }
  set package(value: SIV_Package) {
    super.set("package", value);
  }

  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass(
  "SIV_DeliveryNotePackage",
  SIV_DeliveryNotePackage,
);
